import { render, staticRenderFns } from "./LeaveManagement.vue?vue&type=template&id=015b1c47&scoped=true"
import script from "./LeaveManagement.vue?vue&type=script&lang=js"
export * from "./LeaveManagement.vue?vue&type=script&lang=js"
import style0 from "./LeaveManagement.vue?vue&type=style&index=0&id=015b1c47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b1c47",
  null
  
)

export default component.exports